// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"152":"89fd2349","443":"8b76d5c1","796":"52d9f43e"}[chunkId] + ".css";
};